import { Button, TextField } from '@mollybet/ui';
import useDispatch from 'common/hooks/useDispatch';
import useSelector from 'common/hooks/useSelector';
import { doLogin } from 'common/state/auth/thunkActions';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const LoginFormElement = styled.form`
  display: grid;
  grid-template-rows: auto auto auto auto;
  justify-items: center;
  align-items: center;
`;

const ForgotLink = styled(Link)`
  color: inherit;
  text-decoration: none;
  cursor: pointer;
  width: fit-content;
  padding-bottom: 0.125rem;
  border-bottom: 1px dashed;
  font-size: 0.875rem;
  margin-right: 0.5rem;
  opacity: 0.5;
  transition: opacity 300ms;
  margin-top: 1.25rem;

  &:hover {
    opacity: 1;
  }
`;

const SubmitButton = styled(Button)`
  width: 100%;
  margin-top: 0.75rem;
`;

const ErrorMessage = styled.div`
  color: ${({ theme }) => theme.danger};
  margin-bottom: 1rem;
  max-width: 300px;
`;

export const LoginForm = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const dispatch = useDispatch();
  const loginState = useSelector((state) => state.auth);

  const submitLogin = (event: React.FormEvent) => {
    event.preventDefault();
    dispatch(doLogin(username, password));
  };

  return (
    <LoginFormElement onSubmit={submitLogin}>
      {loginState.error && (
        <ErrorMessage>{loginState.error.split(':').slice(-1)[0]}</ErrorMessage>
      )}
      <TextField
        style={{ width: 300 }}
        label="Username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
      />
      <TextField
        style={{ width: 300 }}
        type="password"
        label="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <SubmitButton
        type="submit"
        variant="primary"
        disabled={!username || !password}
      >
        Login
      </SubmitButton>
      <ForgotLink to="/forgotPassword">Forgot your password?</ForgotLink>
    </LoginFormElement>
  );
};
